module.exports = __webpack_public_path__ + "img/logement-etage-rdc.50ff08e6.png";